import { render } from "./CommessaDettaglio.vue?vue&type=template&id=fa5861ec&scoped=true"
import script from "./CommessaDettaglio.vue?vue&type=script&lang=js"
export * from "./CommessaDettaglio.vue?vue&type=script&lang=js"

import "./CommessaDettaglio.vue?vue&type=style&index=0&id=fa5861ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5861ec"]])

export default __exports__